import React from 'react';

const Spinner = () => {
  return (
    <>
      <style>
        {`
          .spinner-overlay {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            width: 100vw;
            display: flex;
            justify-content: center;
            align-items: center;
            background: white;
            z-index: 9999;
          }

          .spinner {
            width: 40px;
            height: 40px;
            position: relative;
          }

          .spinner div {
            transform-origin: 20px 20px;
            animation: spinnerFade 1.2s linear infinite;
          }

          .spinner div:after {
            content: " ";
            display: block;
            position: absolute;
            top: 3px;
            left: 18px;
            width: 4px;
            height: 10px;
            border-radius: 20%;
            background: black;
          }

          .spinner div:nth-child(1)  { transform: rotate(0deg); animation-delay: -1.1s; }
          .spinner div:nth-child(2)  { transform: rotate(30deg); animation-delay: -1.0s; }
          .spinner div:nth-child(3)  { transform: rotate(60deg); animation-delay: -0.9s; }
          .spinner div:nth-child(4)  { transform: rotate(90deg); animation-delay: -0.8s; }
          .spinner div:nth-child(5)  { transform: rotate(120deg); animation-delay: -0.7s; }
          .spinner div:nth-child(6)  { transform: rotate(150deg); animation-delay: -0.6s; }
          .spinner div:nth-child(7)  { transform: rotate(180deg); animation-delay: -0.5s; }
          .spinner div:nth-child(8)  { transform: rotate(210deg); animation-delay: -0.4s; }
          .spinner div:nth-child(9)  { transform: rotate(240deg); animation-delay: -0.3s; }
          .spinner div:nth-child(10) { transform: rotate(270deg); animation-delay: -0.2s; }
          .spinner div:nth-child(11) { transform: rotate(300deg); animation-delay: -0.1s; }
          .spinner div:nth-child(12) { transform: rotate(330deg); animation-delay: 0s; }

          @keyframes spinnerFade {
            0%   { opacity: 1; }
            100% { opacity: 0; }
          }
        `}
      </style>

      <div className="spinner-overlay">
        <div className="spinner">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i}></div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Spinner;
